import { authMiddleware, RelayNetworkLayer, urlMiddleware } from "react-relay-network-modern";
import { persistedQueries } from "./persisted-queries";
export const network = ({
  authOptions,
  urlOptions
}) => new RelayNetworkLayer([urlMiddleware({
  credentials: "include",
  ...urlOptions
}), authMiddleware({
  ...authOptions
}), persistedQueries({
  useGETForHashedQueries: true
})]);